module.exports = __webpack_public_path__ + "img/engineering.d5135992.webp";